<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">

          <v-container>
            <v-row align="center">

              <v-col cols="12">
                <span class="ml-1 mb-2">차량 번호</span><span class="red--text">*</span>
                <v-row align="center">
                  <v-col cols="9" class="my-0 py-0">
                    <v-row justify="space-around" align="center">
                      <v-col cols="4">
                        <v-select
                            dense
                            v-model="local"
                            :items="localItems"
                            solo
                            menu-props="{offsetY: true}"
                            hide-details
                            required
                            placeholder="지역"
                            :rules="[v => !!v]"
                            color="navy"
                        ></v-select>
                      </v-col>
                      <v-col cols="2" class="mx-0 px-0">
                        <v-text-field v-model="plateNo1" placeholder="000" solo dense hide-details
                                      v-mask="['###','##']"
                                      :autofocus="true" color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center"><span>-</span></v-col>
                      <v-col cols="2" class="mx-0 px-0">
                        <v-text-field v-model="plateNo2" placeholder="바" solo dense hide-details :autofocus="true"
                                      color="navy" maxlength="1"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center"><span>-</span></v-col>
                      <v-col cols=2 class="mx-0 px-0">
                        <v-text-field v-model="plateNo3" placeholder="0000" solo dense hide-details :autofocus="true"
                                      v-mask="['####']"
                                      color="navy"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="my-0 py-0">
                    <c-btn color="blue" outlined @click="reqPlateNoDupl" :disabled="plateNoDuplBtnFlag">중복검사</c-btn>
                  </v-col>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="5">
                <span class="ml-1 mb-2">차종</span><span class="red--text">*</span>
                <v-select
                  dense
                  v-model="seatCnt"
                  :items="getSeatCnt"
                  item-text="configName"
                  item-value="configValue"
                  solo
                  menu-props="{offsetY: true}"
                  hide-details
                  required
                  placeholder="차종을 선택해주세요"
                  :rules="[v => !!v]"
                  :disabled="vehicleFormData? true : false"
                  color="navy"
                ></v-select>
              </v-col>
              <v-col cols="7">
                <span class="ml-1 mb-2">모델명</span>
                <v-select
                  dense solo
                  v-model="vehicleModelId"
                  :items="getVehicleModel"
                  item-text="modelName"
                  item-value="id"
                  menu-props="{offsetY: true}"
                  hide-details
                  placeholder="모델을 선택해주세요"
                  :disabled="vehicleFormData && vehicleFormData.vehicleModelId ? true : false"
                  color="navy"
                ></v-select>
              </v-col>
              <v-divider class="mt-3"></v-divider>


              <v-col cols="12">
                <span class="ml-1 mb-2">담당 기사1</span>
                <v-row class="px-3">
                  <v-text-field v-model="mainDriverName" placeholder="" solo dense required :rules="[v => !!v]"
                                disabled hide-details color="navy"></v-text-field>
                  <v-icon class="ml-1" @click="() => { this.mainDriverName = ''; this.mainDriverId = ''; }">close
                  </v-icon>
                  <c-btn class="ml-3" outlined color="blue"
                         @click="()=>{this.availableDriverFilter = null; this.selectDriverMenu1 = true;}">기사검색
                  </c-btn>
                  <v-menu
                    v-model="selectDriverMenu1"
                    :close-on-content-click="false"
                    :nudge-width="250"
                    :position-x="getMenuPositionX"
                    :position-y="getMenuPositionY"
                    max-height="600"
                  >
                    <c-card min-height="350px" min-width="400px" class="white ma-0 pa-0" title="담당 기사1 검색">
                      <v-text-field
                        v-model="availableDriverFilter" append-outer-icon="search"
                        placeholder= "이름" solo dense hide-details autofocus color="navy"
                      ></v-text-field>
                      <v-list>
                        <v-list-item>
                          <v-row>
                            <v-col cols="5">이름</v-col>
                            <v-col cols="7">연락처</v-col>
                          </v-row>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="driverSearchList">
                          <v-list-item v-for="driver in filteredAvailableDrivers" @click="onSelectDriver(driver, 1)">
                            <v-row>
                              <v-col cols="5">
                                {{driver.name.split("|")[0]}}
                                <v-icon v-if="setDriverColor(driver.name)" class="blue--text">fiber_manual_record
                                </v-icon>
                              </v-col>
                              <v-col cols="7">{{driver.mobileNo}}</v-col>
                            </v-row>
                          </v-list-item>
                        </div>
                      </v-list>
                    </c-card>
                  </v-menu>
                </v-row>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">담당 기사2</span>
                <v-row class="px-3">
                  <v-text-field v-model="subDriver1Name" placeholder="" solo dense required :rules="[v => !!v]"
                                disabled hide-details color="navy"></v-text-field>
                  <v-icon class="ml-1" @click="() => { this.subDriver1Name = ''; this.subDriver1Id = ''; }">close
                  </v-icon>
                  <c-btn class="ml-3" outlined color="blue"
                         @click="()=>{this.availableDriverFilter = null; this.selectDriverMenu2 = true;}">기사검색
                  </c-btn>
                  <v-menu
                    v-model="selectDriverMenu2"
                    :close-on-content-click="false"
                    :nudge-width="250"
                    :position-x="getMenuPositionX"
                    :position-y="getMenuPositionY"
                  >
                    <c-card min-height="350px" min-width="400px" class="white ma-0 pa-0" title="담당 기사2 검색">
                      <v-text-field v-model="availableDriverFilter" append-outer-icon="search"
                                    placeholder="이름" solo dense hide-details autofocus color="navy">
                      </v-text-field>
                      <v-list>
                        <v-list-item>
                          <v-row>
                            <v-col cols="5">이름</v-col>
                            <v-col cols="7">연락처</v-col>
                          </v-row>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="driverSearchList">
                          <v-list-item v-for="driver in filteredAvailableDrivers" @click="onSelectDriver(driver, 2)">
                            <v-row>
                              <v-col cols="5">
                                {{driver.name.split("|")[0]}}
                                <v-icon v-if="setDriverColor(driver.name)" class="blue--text">fiber_manual_record
                                </v-icon>
                              </v-col>
                              <v-col cols="7">{{driver.mobileNo}}</v-col>
                            </v-row>
                          </v-list-item>
                        </div>
                      </v-list>
                    </c-card>
                  </v-menu>
                </v-row>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">담당 기사3</span>
                <v-row class="px-3">
                  <v-text-field v-model="subDriver2Name" placeholder="" solo dense required :rules="[v => !!v]"
                                disabled hide-details color="navy"></v-text-field>
                  <v-icon class="ml-1" @click="() => { this.subDriver2Name = ''; this.subDriver2Id = ''; }">close
                  </v-icon>
                  <c-btn class="ml-3" outlined color="blue"
                         @click="()=>{this.availableDriverFilter = null; this.selectDriverMenu3 = true;}">기사검색
                  </c-btn>
                  <v-menu
                    v-model="selectDriverMenu3"
                    :close-on-content-click="false"
                    :nudge-width="250"
                    :position-x="getMenuPositionX"
                    :position-y="getMenuPositionY"
                    max-height="600"
                  >
                    <c-card min-height="350px" min-width="400px" class="white ma-0 pa-0" title="담당 기사3 검색">
                      <v-text-field v-model="availableDriverFilter" append-outer-icon="search"
                                    placeholder="이름" solo dense hide-details autofocus color="navy">
                      </v-text-field>
                      <v-list>
                        <v-list-item>
                          <v-row>
                            <v-col cols="5">이름</v-col>
                            <v-col cols="7">연락처</v-col>
                          </v-row>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="driverSearchList">
                          <v-list-item v-for="driver in filteredAvailableDrivers" @click="onSelectDriver(driver,3)">
                            <v-row>
                              <v-col cols="5">
                                {{driver.name.split("|")[0]}}
                                <v-icon v-if="setDriverColor(driver.name)" class="blue--text">fiber_manual_record
                                </v-icon>
                              </v-col>
                              <v-col cols="7">{{driver.mobileNo}}</v-col>
                            </v-row>
                          </v-list-item>
                        </div>
                      </v-list>

                    </c-card>
                  </v-menu>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">H/W 장착 여부</span><span class="red--text">*</span>
                <v-radio-group  row dense  v-model="hwUsage">
                  <v-radio label="미장착" value="N"></v-radio>
                  <v-radio label="장착" value="Y" :disabled=true ></v-radio>
                  <v-radio label="이용불가" value="NA"></v-radio>
                </v-radio-group>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">차량 옵션</span>
                <v-row class="ml-1 mb-2">
                  <v-radio-group  row dense v-model="display.vehicleOption.flag" @change="changeFlagVehicleOption">
                    <v-radio label="미장착" :value="false"></v-radio>
                    <v-radio label="장착" :value="true"></v-radio>
                  </v-radio-group>
                  <v-checkbox
                      v-for="vehicleOption in getVehicleOption"
                      v-model="selectedVehicleOption"
                      :label="vehicleOption.configName"
                      :value="vehicleOption.configValue"
                      @change="selectVehicleOption"
                      class="mr-3" dense>
                  </v-checkbox>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="6">
                <v-menu
                  v-model="registrationMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <v-text-field
                        v-model="registrationDate"
                        label="차량등록일*"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        error
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker v-model="registrationDate" @input="registrationMenu = false" firstDayOfWeek="1" :selectedDate="registrationDate" locale="ko-kr"></c-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="expirationMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <v-text-field
                        v-model="expirationDate"
                        label="차량만료일*"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        error
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker v-model="expirationDate" @input="expirationMenu = false" firstDayOfWeek="1" :selectedDate="expirationDate" locale="ko-kr"></c-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">정기점검일</span><span class="red--text">*</span>
                <v-row justify="space-around" align="center">
                  <span class="ml-4">매년</span>
                  <v-select
                    class="birth-select"
                    dense
                    v-model="inspectionMonth"
                    :items="selectMonths"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="선택"
                    color="navy"
                  ></v-select>
                  <span>월</span>
                  <v-select
                    class="birth-select"
                    dense
                    style="width:50px"
                    v-model="inspectionDay"
                    :items="selectDays"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="선택"
                    color="navy"
                  ></v-select>
                  <span>일</span>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </v-col>
            </v-row>

            <v-row justify="center">
              <c-btn v-if="vehicleFormData" class="mr-1 mt-2" color="blue" outlined @click="onUpdateVehicle">수정</c-btn>
              <c-btn v-else color="blue" class="mr-1 mt-2" outlined @click="onAddVehicle">등록</c-btn>
              <c-btn class="mt-2" color="gray" outlined
                     @click="() => { this.openFlag = false; this.placeholder ='(ex. 스타렉스, 스파크 2019년형 ...)';}">취소
              </c-btn>
            </v-row>
          </v-container>
        </v-form>

      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import {mask} from 'vue-the-mask';

  export default {
    directives: {mask},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      vehicleFormData: {
        type: Object,
        default: undefined
      },
      availableDrivers: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        openFlag: false,

        registrationMenu: false,
        expirationMenu: false,

        // vehicle Info
        hwUsage: 'N',
        local: '',
        plateNo: '',
        plateNo1: '',
        plateNo2: '',
        plateNo3: '',
        seatCnt: '',
        vehicleModelId: '',

        mainDriverName: '',
        mainDriverId: '',
        subDriver1Name: '',
        subDriver1Id: '',
        subDriver2Name: '',
        subDriver2Id: '',
        confirm: 'f',

        selectAllVehicleOption: false,
        selectedVehicleOption: [],

        registrationDate: this.$func.curDateString(),
        expirationDate: this.$func.curDateString(),
        inspectionDay: '',
        inspectionMonth: '',


        filteredAvailableDrivers: [],
        availableDriverFilter: '',
        vehicleModelList: [],

        selectDriverMenu1: false,
        selectDriverMenu2: false,
        selectDriverMenu3: false,

        selectMonths: [],
        selectDays: [],


        placeholder: '(ex. 스타렉스, 스파크 2019년형 ...)',
        plateNoDuplFlag: false,
        pattern: /^(\d{2,3}) ([가-힣]) (\d{4})$/,
        patternKorean: /^([ㄱ-ㅎㅏ-ㅣ가-힣]){1,2}$/,

        localItems: [
            '강원',
            '경기',
            '경남',
            '경북',
            '광주',
            '대구',
            '대전',
            '부산',
            '서울',
            '세종',
            '울산',
            '인천',
            '전남',
            '전북',
            '제주',
            '충남',
            '충북',
            '(없음)'
        ],
        display: {
          vehicleOption: {
            options: [],
            flag: false
          }
        }
      }
    },
    created() {
      this.$store.state.config.car_option.forEach(item => {
        if(item.configValue !=='c_all' && item.configValue !=='c_null') this.display.vehicleOption.options.push(item.configValue)
      })
    },
    mounted() {
      let months = [];
      let days = [];

      for (let i = 1; i < 13; i++) {
        if (i < 10) i = '0' + i;
        else i = i + '';
        months.push(i);
      }
      for (let i = 1; i < 32; i++) {
        if (i < 10) i = '0' + i;
        else i = i + '';
        days.push(i);
      }
      this.selectMonths = months;
      this.selectDays = days;

      this.reqGetVehicleModelList();
    },
    watch: {
      availableDrivers(value) {
        this.filteredAvailableDrivers = value;
      },
      availableDriverFilter(value) {
        this.filteredAvailableDrivers = this.availableDrivers ? this.availableDrivers.filter(
          item => {
            if (!value) return true;
            return item.name.indexOf(value) > -1;
          }) : [];
      },
      open(value) {
        this.initData();

        if (value && this.vehicleFormData) {
          this.id = this.vehicleFormData.id;
          this.mainDriverId = this.vehicleFormData.mainDriverId;
          this.mainDriverName = this.vehicleFormData.mainDriverName;
          this.subDriver1Id = this.vehicleFormData.subDriver1Id;
          this.subDriver1Name = this.vehicleFormData.subDriver1Name;
          this.subDriver2Id = this.vehicleFormData.subDriver2Id;
          this.subDriver2Name = this.vehicleFormData.subDriver2Name;

          if (this.vehicleFormData.plateNo.split(' ').length > 3) {
            this.local = this.vehicleFormData.plateNo.split(' ')[0];
            this.plateNo1 = this.vehicleFormData.plateNo.split(' ')[1];
            this.plateNo2 = this.vehicleFormData.plateNo.split(' ')[2];
            this.plateNo3 = this.vehicleFormData.plateNo.split(' ')[3];
          } else {
            this.local = '(없음)';
            this.plateNo1 = this.vehicleFormData.plateNo.split(' ')[0];
            this.plateNo2 = this.vehicleFormData.plateNo.split(' ')[1];
            this.plateNo3 = this.vehicleFormData.plateNo.split(' ')[2];
          }
          this.seatCnt = this.vehicleFormData.seatCnt;
          this.vehicleModelId = this.vehicleFormData.vehicleModelId;
          this.registrationDate = this.$func.dateToString(this.vehicleFormData.registrationDate);
          this.expirationDate = this.$func.dateToString(this.vehicleFormData.expirationDate);
          this.hwUsage = this.vehicleFormData.hwUsage;
          this.confirm = this.vehicleFormData.confirm;

          const inspectionDate = this.vehicleFormData.inspectionDate.split('-');
          this.inspectionMonth = inspectionDate[0];
          this.inspectionDay = inspectionDate[1];
          this.setVehicleOption(this.vehicleFormData.vehicleOption)
        }

        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      inspectionMonth(value) {
        this.selectDays = days;
        let days = [];
        switch (value) {
          case '02' :
            for (let i = 1; i <= 29; i++) {
              if (i < 10) i = '0' + i;
              else i = i + '';
              days.push(i);
            }
            break;
          case '04' :
          case '06' :
          case '09' :
          case '11' :
            for (let i = 1; i <= 30; i++) {
              if (i < 10) i = '0' + i;
              else i = i + '';
              days.push(i);
            }
            break;
          default :
            for (let i = 1; i <= 31; i++) {
              if (i < 10) i = '0' + i;
              else i = i + '';
              days.push(i);
            }
            break;
        }
        this.selectDays = days;
      },
      plateNo1(value) {
        if (!this.vehicleFormData) {
          this.plateNoDuplFlag = false;
        }
      },
      plateNo2(value) {
        if (!this.vehicleFormData) {
          this.plateNoDuplFlag = false;
        }
        if(!this.patternKorean.test(value)) {
          setTimeout(() => {
            this.plateNo2 = ''
          }, 1);
        }
      },
      plateNo3(value) {
        if (!this.vehicleFormData) {
          this.plateNoDuplFlag = false;
        }
      }
    },
    computed: {
      getMenuPositionX() {
        return window.innerWidth / 2;
      },
      getMenuPositionY() {
        return window.innerHeight / 2;
      },
      getSeatCnt() {
        return this.$store.state.config.seat_cnt;
      },
      onDialogTitle() {
        return this.vehicleFormData ? '차량 정보 수정' : '차량 정보 등록';
      },
      getVehicleModel() {
        return this.vehicleModelList.filter(item => item.seatCnt.configValue === this.seatCnt);
      },
      plateNoDuplBtnFlag() {
        if (this.vehicleFormData) {
          this.plateNo = this.setPlateNo();

          if (this.vehicleFormData.plateNo === this.plateNo) {
            this.plateNoDuplFlag = true;
            return true;
          } else {
            this.plateNoDuplFlag = false;
            return false;
          }
        }
      },
      getVehicleOption() {
        return this.$store.state.config.car_option.filter(item => item.configValue !== 'c_all' && item.configValue !== 'c_null');
      },
    },
    methods: {
      initData() {
        this.id = '';
        this.mainDriverId = '';
        this.mainDriverName = '';
        this.subDriver1Id = '';
        this.subDriver1Name = '';
        this.subDriver2Id = '';
        this.subDriver2Name = '';
        this.local = '';
        this.plateNo = '';
        this.plateNo1 = '';
        this.plateNo2 = '';
        this.plateNo3 = '';
        this.seatCnt = '';
        this.vehicleModelId = '';
        this.hwUsage = 'N';
        this.registrationDate = this.$func.curDateString();
        this.expirationDate = this.$func.curDateString();
        this.inspectionDate = '';
        this.confirm = 'f';

        this.inspectionDay = '';
        this.inspectionMonth = '';
        this.selectedVehicleOption = [];
      },

      onSelectDriver(selected, value) {
        // value : 기사 구분 (1: 메인, 2: 서브1, 3: 서브2)
        switch (value) {
          case 1:
            if (selected.id === this.subDriver1Id || selected.id === this.subDriver2Id) {
              this.selectDriverMenu1 = false;
              this.duplicateDriverDialog();
              return;
            }
            this.mainDriverName = selected.name ? selected.name.split('|')[0] : '';
            this.mainDriverId = selected.id;
            this.selectDriverMenu1 = false;
            break;
          case 2:
            if (selected.id === this.mainDriverId || selected.id === this.subDriver2Id) {
              this.selectDriverMenu2 = false;
              this.duplicateDriverDialog();
              return;
            }
            this.subDriver1Name = selected.name ? selected.name.split('|')[0] : '';
            this.subDriver1Id = selected.id;
            this.selectDriverMenu2 = false;
            break;
          case 3:
            if (selected.id === this.mainDriverId || selected.id === this.subDriver1Id) {
              this.selectDriverMenu3 = false;
              this.duplicateDriverDialog();
              return;
            }
            this.subDriver2Name = selected.name ? selected.name.split('|')[0] : '';
            this.subDriver2Id = selected.id;
            this.selectDriverMenu3 = false;
            break;
        }

      },
      duplicateDriverDialog() {
        this.$store.commit('alert', {open: true, timeout: 3000, msg: `담당 기사가 중복 됩니다.\n다른 기사를 선택해주세요.`})
      },
      onAddVehicle() {
        // if (!(this.$refs.form.validate())) {
        if (!this.plateNo1 || !this.plateNo2 || !this.plateNo3 || !this.seatCnt
          || !this.hwUsage || !this.registrationDate
          || !this.expirationDate || !this.inspectionMonth
          || !this.inspectionDay) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        this.plateNo = this.plateNo1 + ' ' + this.plateNo2 + ' ' + this.plateNo3;
        if (!this.pattern.test(this.plateNo)) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '차량번호 형식이 잘못되었습니다.'});
          return;
        }

        if (!this.plateNoDuplFlag) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '차량번호 중복검사를 해주세요.'});
          return;
        }

        let registrationDate = this.$func.stringToDate(this.registrationDate);
        let expirationDate = this.$func.stringToDate(this.expirationDate);
        if(this.$moment.duration(expirationDate.diff(registrationDate)).asDays() < 0) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '만료일이 등록일보다 이전이 될 수 없습니다.'});
          return;
        }
        
        const vehicleOption = this.display.vehicleOption.flag ? this.selectedVehicleOption.join() : 'c_null'

        let reqData = {
          plateNo: this.setPlateNo(),
          seatCnt: this.seatCnt,
          mainDriver: this.mainDriverId,
          subDriver1: this.subDriver1Id,
          subDriver2: this.subDriver2Id,
          hwUsage: this.hwUsage,
          registrationDate: this.registrationDate,
          expirationDate: this.expirationDate,
          inspectionDate: this.inspectionMonth + '-' + this.inspectionDay,
          confirm: this.confirm,
          vehicleOption: vehicleOption
        }

        if(this.vehicleModelId)
          reqData.vehicleModelId = this.vehicleModelId;

        this.$emit('reqAddVehicle', reqData);
      },

      onUpdateVehicle() {
        if (!this.plateNo1 || !this.plateNo2 || !this.plateNo3
          || !this.hwUsage || !this.registrationDate
          || !this.expirationDate || !this.inspectionMonth
          || !this.inspectionDay) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        this.plateNo = this.plateNo1 + ' ' + this.plateNo2 + ' ' + this.plateNo3;
        if (!this.pattern.test(this.plateNo)) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '차량번호 형식이 잘못되었습니다.'});
          return;
        }

        if (!this.plateNoDuplFlag) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '차량번호 중복검사를 해주세요.'});
          return;
        }

        const vehicleOption = this.display.vehicleOption.flag ? this.selectedVehicleOption.join() : 'c_null'

        let reqData = {
          id: this.vehicleFormData.id,
          plateNo: this.setPlateNo(),
          mainDriver: this.mainDriverId,
          subDriver1: this.subDriver1Id,
          subDriver2: this.subDriver2Id,
          hwUsage: this.hwUsage,
          registrationDate: this.registrationDate,
          expirationDate: this.expirationDate,
          inspectionDate: this.inspectionMonth + '-' + this.inspectionDay,
          confirm: this.confirm,
          state: 'Enable',
          vehicleOption: vehicleOption
        }

        if(this.vehicleModelId)
          reqData.vehicleModelId = this.vehicleModelId;


        this.$emit('reqUpdateVehicle', reqData);

      },


      setDriverColor(data) {
        return data.indexOf('M') !== -1;
      },
      async reqPlateNoDupl() {
        try {
          if (!this.plateNo1 || !this.plateNo2 || !this.plateNo3) {
            this.$store.commit('snackbar', {timeout: 2000, msg: '차량번호를 입력해주세요.'});
            return;
          }
          this.plateNo = this.setPlateNo();

          const response = await this.$api.plateNoDulpCheck(this.plateNo);
          if (response.data === true) {
            this.plateNoDuplFlag = true;
            this.$store.commit('snackbar', {timeout: 2000, msg: '등록 가능한 차량입니다.', color: 'blue'});
          } else {
            this.$store.commit('snackbar', {timeout: 2000, msg: '이미 등록된 차량입니다.'});
            this.plateNo = ''
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqPlateNoDupl'});
        }
      },
      async reqGetVehicleModelList() {
        try {
          const res = await this.$api.getVehicleModelList();
          this.vehicleModelList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetVehicleModelList'});
        }
      },
      setVehicleOption(data) {
        const options = data ? data.split(',') : ['c_null']
        console.log(options.indexOf('c_null') )
        const flag = options.indexOf('c_null') === 0 ? false : true
        this.display.vehicleOption.flag = flag
        if(flag) {
          options.forEach((val) => {
            console.log(val)
            this.selectedVehicleOption.push(val); 
          });
        }
      },
      setPlateNo() {
        if (!this.local || this.local === '(없음)') {
          return this.plateNo1 + ' ' + this.plateNo2 + ' ' + this.plateNo3;
        } else {
          return this.local + ' ' + this.plateNo1 + ' ' + this.plateNo2 + ' ' + this.plateNo3;
        }
      },
      changeFlagVehicleOption(e) {
        this.selectedVehicleOption = []
        const flag = typeof(e) === "undefined" ? false : e
        this.selectedVehicleOption = flag ? this.display.vehicleOption.options : []
      },
      selectVehicleOption() {
        this.display.vehicleOption.flag = this.selectedVehicleOption.length > 0 ? true : false
      }
    },
  }
</script>
<style lang="scss">
  .driverSearchList {
    height: 200px;
    overflow-y: auto;
  }
  .birth-select {
    width: 50px !important;
    margin: 0 10px !important;
  }
</style>
